module.exports = __webpack_public_path__ + "img/security-user.698e5410.svg";